import { render, staticRenderFns } from "./ResendVerification.vue?vue&type=template&id=d672201c&scoped=true&"
import script from "./ResendVerification.vue?vue&type=script&lang=js&"
export * from "./ResendVerification.vue?vue&type=script&lang=js&"
import style0 from "./ResendVerification.vue?vue&type=style&index=0&id=d672201c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d672201c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
